import {SavedFiltersSectionConfig} from 'filters/features/FilterDialog/types';

import {useEditedFilterContext} from 'filters/features/FilterDialog/contexts/internal/EditedFilterProvider/EditedFilterProvider';
import {useFilterActionsContext} from 'filters/contexts/FilterActionsProvider/FilterActionsProvider';

import {PrimaryActionButton} from 'modules/decisionsNext/components/DecisionsDialog';

export const SavedFiltersPrimaryAction = ({savedId}: Omit<SavedFiltersSectionConfig, 'footer'>) => {
  const {setFilter} = useEditedFilterContext();
  const {useStoredFilters} = useFilterActionsContext();
  const {savedFilters: filters} = useStoredFilters();

  return (
    <PrimaryActionButton
      type='submit'
      disabled={!savedId}
      onClick={() => {
        const filter = savedId?.startsWith('filter-preset')
          ? filters.presets?.find(filter => filter.id === savedId)?.filter
          : filters.saved?.find(filter => filter.id === savedId)?.filter;

        if (!filter) {
          throw new Error(`No filter found ${savedId}`);
        }

        setFilter(filter);
      }}
    >
      Apply filters
    </PrimaryActionButton>
  );
};
